import { defineAction } from '~/prix'
import pointOfInterestUpdateAction from './pointOfInterestUpdate.action.json' assert { type: 'json' }
import { pointOfInterestObject } from '../pointOfInterestObject'
import { z } from 'zod'

const pointOfInterestUpdateDefinition = defineAction({
  ...pointOfInterestUpdateAction,

  input: pointOfInterestObject.pick({
    id: true,
    plusCode: true,
    title: true,
    observation: true,
    whatsapp: true,
    alternatePhone: true,
    wifiSsid: true,
    wifiPassword: true,
    latitude: true,
    longitude: true,
    accuracy: true,
    type: true,
    communityId: true,
    buildingId: true,
    fullAddress: true,
    updatedAt: true,
  }),
  output: z.object({}),
})

export default pointOfInterestUpdateDefinition
